import React, { useEffect, useState } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import './App.css';

const profiles = [
  {
    name: "Fatima Al-Husseini",
    title: "Entrepreneur & Philanthropist",
    blurb: "Founded a successful tech startup and has dedicated resources to improving education access in rural communities across Lebanon.",
    image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=400&h=400&fit=crop"
  },
  {
    name: "Dr. Khalil Mdoukha",
    title: "Renowned Surgeon",
    blurb: "Pioneering cardiac surgeon who has trained hundreds of medical professionals and established free clinics serving underprivileged communities.",
    image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&h=400&fit=crop"
  },
  {
    name: "Layla Nassif",
    title: "Award-Winning Author",
    blurb: "Published internationally acclaimed novels celebrating Lebanese culture and heritage. Her works have been translated into 15 languages.",
    image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&h=400&fit=crop"
  },
  {
    name: "Rashid Hayek",
    title: "Community Leader",
    blurb: "Dedicated his life to preserving Mdoukha's cultural heritage through museums, cultural festivals, and youth mentorship programs.",
    image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=400&h=400&fit=crop"
  }
];

export default function Profile() {
  const [currentProfileIndex, setCurrentProfileIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentProfileIndex((prev) => (prev + 1) % profiles.length);
    }, 5000);
    return () => clearInterval(interval);
  }, []);

  const nextProfile = () => setCurrentProfileIndex((p) => (p + 1) % profiles.length);
  const prevProfile = () => setCurrentProfileIndex((p) => (p - 1 + profiles.length) % profiles.length);

  const currentProfile = profiles[currentProfileIndex];

  return (
    <section className="profiles-page">
      <div className="profile-card">
        <img src={currentProfile.image} alt={currentProfile.name} className="profile-image" />

        <h2 className="profile-name">{currentProfile.name}</h2>
        <p className="profile-title">{currentProfile.title}</p>
        <p className="profile-blurb">{currentProfile.blurb}</p>

        <div className="profile-controls">
          <button onClick={prevProfile} className="btn-circle" aria-label="Previous">
            <ChevronLeft size={20} />
          </button>

          <div className="indicators">
            {profiles.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentProfileIndex(index)}
                className={`indicator ${index === currentProfileIndex ? 'active' : ''}`}
                aria-label={`Profile ${index + 1}`}
              />
            ))}
          </div>

          <button onClick={nextProfile} className="btn-circle" aria-label="Next">
            <ChevronRight size={20} />
          </button>
        </div>

        <p className="profile-meta">Profile {currentProfileIndex + 1} of {profiles.length}</p>
      </div>
    </section>
  );
}
